import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import * as React from 'react';
import { debitOrCreditCardMsg, invoiceMsg, t } from '../../../../common/i18n';
import { Order } from '../../../../generated/api/order.js';

import './SelectPaymentMethod.scss';

const OptionId = {
  BILLING_ACCOUNT: 'billing-account-payment',
  CARD: 'card-payment',
} as const;

type PaymentOptionConfig = {
  id: string;
  name: string;
  description?: string;
  icon?: React.ReactNode;
};

const paymentOptions: PaymentOptionConfig[] = [
  {
    id: OptionId.BILLING_ACCOUNT,
    name: t.JF65(invoiceMsg),
    description: t.GRAL('Email invoice, E-invoice or Paper invoice'),
    icon: <CL.Icon icon="invoice" size="l" />,
  },
  {
    id: OptionId.CARD,
    name: t.UKMC(debitOrCreditCardMsg),
    description: 'Visa, Mastercard',
    icon: <CL.Icon icon="money" size="l" />,
  },
];

const optionIdToPaymentType: Record<string, Order.PaymentTypeEnum> = {
  [OptionId.BILLING_ACCOUNT]: Order.PaymentTypeEnum.BILLING_ACCOUNT,
  [OptionId.CARD]: Order.PaymentTypeEnum.CARD,
};

export interface SelectPaymentMethodProps {
  paymentType: Order.PaymentTypeEnum;
  onChange: (paymentType: Order.PaymentTypeEnum) => void;
  label?: string;
  className?: string;
  id?: string;
}

export const SelectPaymentMethod = ({
  paymentType,
  onChange,
  label = t.CBBN('Choose payment method'),
  className,
}: SelectPaymentMethodProps) => {
  const value = paymentType === Order.PaymentTypeEnum.BILLING_ACCOUNT ? OptionId.BILLING_ACCOUNT : OptionId.CARD;

  return (
    <CL.SelectGroup
      label={label}
      className={classNames('of-payment-method-selectgroup', className)}
      products={paymentOptions}
      value={value}
      onChange={(optionId: string) => {
        const mapped = optionIdToPaymentType[optionId];
        if (mapped) {
          onChange(mapped);
        }
      }}
    />
  );
};

export const SelectPaymentMethodIds = OptionId;
